/**
 * Save data and app state.
 *
 * @module saver
 */

'use strict';

var app = require('mag-app');


/**
 * Save app state.
 */
function saveState () {
    // filter fields with empty values, don't store them
    Object.keys(app.state).forEach(function ( key ) {
        if ( !String(app.state[key]) ) {
            delete app.state[key];
        }
    });

    core.state = app.state;
}


/**
 * Initialize saver for working with page.
 *
 * @param {boolean} saveStateEnable - switcher for specifying if saving state is enabled
 * @param {boolean} saveDataEnable - switcher for specifying if saving data is enabled
 *
 * @return {boolean} exit status
 */
function init ( saveStateEnable, saveDataEnable ) {
    var config = ['SEARCH', 'SORT', 'DISPLAY_FAV', 'PANEL_POS'];

    app.state = {};

    if ( Object.prototype.toString.call(core.state).slice(8, -1) !== 'Object' ) {
        core.state = {};
    }

    // restore state
    config.forEach(function ( state ) {
        var value = core.state[state];

        app.state[state] = saveStateEnable ? (value === null || value === undefined ? '' : value) : ''; // eslint-disable-line
    });

    app.saveState = saveStateEnable ? saveState : function () { /* action */ };

    if ( saveDataEnable ) {
        // implement
    }

    return true;
}


module.exports = {
    init: init
};
